/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Keep_AmendmentInputs */

const en_orders_keep_amendment = /** @type {(inputs: Orders_Keep_AmendmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep Amendment`)
};

const es_orders_keep_amendment = /** @type {(inputs: Orders_Keep_AmendmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conservar enmienda`)
};

/**
* | output |
* | --- |
* | "Keep Amendment" |
*
* @param {Orders_Keep_AmendmentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_keep_amendment = /** @type {((inputs?: Orders_Keep_AmendmentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Keep_AmendmentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_keep_amendment(inputs)
	return es_orders_keep_amendment(inputs)
});